// @flow

import Route from 'PMT/flux/Route';



/**
 * Define all the app routes.
 * From the most specific to the least specific ("/" and "*" at the end),
 * because the first matching route is rendered.
 */
class RoutingEnum {

  static STAT_HOME = new Route('stat', '/statistics');

  static LOGIN = new Route('login', '/login', false);

  static FORGOT_PASSWORD = new Route('forgotPassword', '/forgot-password',
      false);

  static LOGOUT = new Route('logout', '/logout');

  static RECEIPT = new Route('receipts', '/receipts');

  //
  // Menu
  //



  //
  // Menu - menu
  //

  static RESTAURANT_MENU_MENU_NEW = new Route(
    'RESTAURANT_MENU_MENU_NEW',
    '/restaurant-menu/menus/new',
  );

  static RESTAURANT_MENU_MENU_EDIT = new Route(
      'RESTAURANT_MENU_MENU_EDIT',
      '/restaurant-menu/menus/:menuId/edit',
  );

  static RESTAURANT_MENU_PART_EDIT = new Route(
      'RESTAURANT_MENU_PART_EDIT',
      '/restaurant-menu/menus/:menuId/parts/:menuPartId/edit',
  );

  static RESTAURANT_MENU_MENU_DETAIL = new Route(
    'RESTAURANT_MENU_MENU_DETAIL',
    '/restaurant-menu/menus/:menuId',
  );

  //
  // Menu - product
  //

  static RESTAURANT_MENU_PRODUCT_NEW = new Route(
    'RESTAURANT_MENU_PRODUCT_NEW',
    '/restaurant-menu/products/new',
  );

  static RESTAURANT_MENU_PRODUCT_EDIT = new Route(
    'RESTAURANT_MENU_PRODUCT_EDIT',
    '/restaurant-menu/products/:productId/edit',
  );

  //
  // Menu - productOption
  //

  static RESTAURANT_MENU_PRODUCT_OPTION_NEW = new Route(
    'RESTAURANT_MENU_OPTION_NEW',
    '/restaurant-menu/options/new',
  );

  static RESTAURANT_MENU_PRODUCT_OPTION_EDIT = new Route(
      'RESTAURANT_MENU_OPTION_EDIT',
      '/restaurant-menu/options/:productOptionId/edit',
  );

  static RESTAURANT_MENU_PRODUCT_OPTION_DETAIL = new Route(
    'RESTAURANT_MENU_OPTION_DETAIL',
    '/restaurant-menu/options/:productOptionId',
  );


  //
  //
  //

  static RESTAURANT_MENU_CATEGORY_DETAIL = new Route(
    'RESTAURANT_MENU_CATEGORY_DETAIL',
    '/restaurant-menu/categories/:categoryId',
  );

  //
  //
  //

  static RESTAURANT_MENU_UPSELLING_CATEGORY_DETAIL = new Route(
    'RESTAURANT_MENU_CATEGORY_DETAIL',
    '/restaurant-menu/upselling-categories/:upsellingCategoryId',
  );

  static RESTAURANT_MENU = new Route(
      'RESTAURANT_MENU',
      '/restaurant-menu',
  );

  /**
   * Promotions
   */

  static ORDERS_CART_MODIFIERS_NEW = new Route(
    'order_cart_modifiers_new',
    '/orders/cart-modifiers/new',
  );
  static ORDERS_CART_MODIFIERS_EDIT = new Route(
    'order_cart_modifiers_edit',
    '/orders/cart-modifiers/:cartModifierId/edit',
  );
  static ORDERS_CART_MODIFIERS_LIST = new Route(
      'order_cart_modifiers_list',
      '/orders/cart-modifiers',
  );


  //
  //
  //

  static ORDER_STATISTICS = new Route(
    'ORDER_STATISTICS',
    '/orders/statistics',
  );

  static ORDER_SETTINGS = new Route(
    'order_settings',
    '/orders/settings',
  );

  static ORDERS_LIST = new Route('order_list', '/orders');

  static RESTAURANT_EDIT = new Route(
    'restaurant_edit',
    '/account',
  );

  static FEATURE_NON_ACTIVATED = new Route(
    'feature_no_activated',
    '/feature-non-activated',
  );

  //
  // RestaurantsGroup
  //
  static RESTAURANTS_GROUP = new Route(
    'restaurants_group',
    '/restaurants-group',
  );

  //
  // Other
  //

  static REDIRECT_PAGE = new Route('redirect', '/redirect');

  static SERVER_ERROR = new Route(
    'server_error',
    '/server-error',
  );

  // -- disabled
  static CGU = new Route('cgu', '/cgu', false);

  // "/" (almost) at the end, because the first matching route is rendered
  static DASHBOARD = new Route('dashboard', '/');

  // latest => any route that is not found will be redirected to the not found page
  static NOT_FOUND = new Route('not_found', '*', false);

}

export default RoutingEnum;
